import { render, staticRenderFns } from "./social_pc.vue?vue&type=template&id=bd02e570&scoped=true&"
import script from "./social_pc.vue?vue&type=script&lang=js&"
export * from "./social_pc.vue?vue&type=script&lang=js&"
import style0 from "./social_pc.vue?vue&type=style&index=0&id=bd02e570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd02e570",
  null
  
)

export default component.exports